import React, {useEffect, useState} from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Helper from "../helpers";
import { isPublicRoute } from "../Services/SiteService.ts";

const PrivateRoute = ({ element }) =>  {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  // Check if current path is a public route
  const isCurrentRoutePublic = isPublicRoute(location.pathname);

  useEffect(() => {
    const fetchToken = async () => {
      if(isCurrentRoutePublic) {
        setLoading(false);
        return;
      }
      else {
        const token = await Helper.getCookie('wh-jwt');
        setToken(token);
        setLoading(false);
      }
    };

    fetchToken();
  }, [isCurrentRoutePublic]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-black">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-500"></div>
      </div>
    );
  }

  // If it's a public route, always render the element
  if (isCurrentRoutePublic) {
    return element;
  }

  // For private routes, check authentication
  return token ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
